import { useEffect, useState } from "react";

/**
 * Retourne `value`, mais mis à jour seulement `delay` ms après le dernier changement.
 * Utilisé pour ne pas déclencher un appel réseau à chaque frappe/curseur ajusté
 * (panneau d'hypothèses de la projection actuarielle).
 */
export const useDebouncedValue = (value, delay = 500) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};

export default useDebouncedValue;
